module.exports = __webpack_public_path__ + "img/trainee-planning.5174ab3e.svg";